<template>
  <b-row v-if="!dataLoad">
    <b-col
      cols="12"
      md="10"
    >
      <SelectOffice
        :show-select-office="true"
      />
    </b-col>
    <b-col
      cols="12"
      md="2"
    >
      <SearchBtnAction
        :view-search-btn="true"
        :data-load="dataLoad"
        :get-all-data="getAllData"
      />
    </b-col>
  </b-row>
</template>

<script>
import SelectOffice from './fixed-filter/SelectOffice.vue'
import SearchBtnAction from '../actions/SearchBtnAction.vue'

export default {
  components: {
    SelectOffice,
    SearchBtnAction,
  },
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Function,
      default: () => () => {},
    },
  },
}
</script>
